import React, { ChangeEventHandler, useState } from 'react';
import styles from './form.module.scss';
import { BorderColors, Invalid } from './InputComponent';

export type Option = {
    value: string;
    label: string;
};

type SelectDropdownProps = {
    id: string;
    label: string;
    selectName: string;
    onChange: ChangeEventHandler<HTMLSelectElement>;
    placeholder: string;
    value: string;
    setValue: Function;
    options: Array<Option>;
    invalid: Invalid;
    toggleInvalid: Function;
    borderColor: BorderColors;
    toggleBorderColor: Function;
};

const generateOptions = (options: Array<Option>) =>
    options.map((option, index) => (
        <option key={`${option.value}-${index}`} value={option.value}>
            {option.label}
        </option>
    ));

const DropdownComponent = ({
    id,
    label,
    selectName,
    options,
    placeholder,
    value,
    setValue,
    invalid,
    toggleInvalid,
    borderColor,
    toggleBorderColor,
}: SelectDropdownProps) => {
    const [visibleNameLabel, toggleVisibleLabel] = useState<Invalid>('none');

    return (
        <div className={styles.dropdownWrapper}>
            {/* <label htmlFor={id} className={styles.label} style={{ display: visibleNameLabel }}>
                {label}
                <span style={{ color: 'var(--primary-red)' }}>*</span>
            </label> */}
            <select
                id={id}
                className={styles.dropdown}
                value={value}
                name={selectName}
                style={{ borderBottomColor: borderColor }}
                aria-label={label}
                onChange={(event) => {
                    setValue(event.target.value);
                    if (event.target.value.length > 0) {
                        toggleBorderColor(null);
                        toggleInvalid('none');
                        toggleVisibleLabel('block');
                    } else {
                        toggleVisibleLabel('none');
                    }
                }}
            >
                {generateOptions(options)}
            </select>
            <span className={styles.invalid} style={{ display: invalid }}>
                Please fill out this field
            </span>
        </div>
    );
};

export default DropdownComponent;
